// These are used by other files
export interface IImagePopup {
  hidden: boolean
  src: string
  caption: string
  alt: string
}

export interface ISetActiveMenuItem {
  to: any
}
// -->

export interface IMenuItem {
  familyLevel: string
  title: string
  slug: string
  children: []
  active: boolean
}
export interface IState {
  message: string
  exhibitionName: string
  footer: string
  imagePopup: IImagePopup
  pagesContent: []
  showMenu: boolean
  routes: []
  menu: IMenuItem[]
  loggedIn: boolean
  icons: [],
  texts:{}
}

const deafultState: IState = {
  message: 'oh, hi mark',
  exhibitionName: '',
  footer: '',
  imagePopup: { hidden: true, src: '', caption: '', alt: '' },
  pagesContent: [],
  routes: [],
  menu: [],
  showMenu: false,
  loggedIn: false,
  icons: [],
  texts:{}
}

export default deafultState
